import { render, staticRenderFns } from "./AppointmentTable.vue?vue&type=template&id=0633f8ca&"
import script from "./AppointmentTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports